<template>
	<v-card-title>
		<v-layout row wrap>
			<v-flex lg3 md6 sm6 xs12 class="pr-3">
				<v-text-field v-debounce:300ms="updateSearch" append-icon="search" label="Search" autofocus="" background-color="#fff"></v-text-field>
			</v-flex>
			<v-flex lg3 md6 sm6 xs12 class="pr-3">
				<tag-selector
					:options="assetCategories"
					:selectedOptions="selectedCategories"
					disableMatchAll
					entityName="category"
					entityNamePlural="categories"
					placeholder="Enter Category"
					@on-selected-tags-change="updateSelectedCategories"
					@on-leave="onLeaveCategorySelector"
				></tag-selector>
			</v-flex>
			<v-flex lg3 md6 sm6 xs12 class="pr-3">
				<tag-selector
					:options="assetLocations"
					:selectedOptions="selectedLocations"
					disableMatchAll
					entityName="location"
					entityNamePlural="locations"
					placeholder="Enter Location"
					@on-selected-tags-change="updateSelectedLocations"
					@on-leave="onLeaveLocationSelector"
				></tag-selector>
			</v-flex>
			<v-flex lg3 md6 sm6 xs12 class="pr-3">
				<tag-selector
					:options="assetStatuses"
					:selectedOptions="selectedStatuses"
					disableMatchAll
					entityName="status"
					entityNamePlural="statuses"
					placeholder="Enter Status"
					@on-selected-tags-change="updateSelectedStatuses"
					@on-leave="onLeaveLocationSelector"
				></tag-selector>
			</v-flex>
		</v-layout>
		<v-layout v-if="!hideActions">
			<v-spacer></v-spacer>
			<v-btn color="primary" @click="$emit('onAddNew')">Add new asset</v-btn>
			<v-tooltip bottom v-if="!hideActions">
				<v-btn slot="activator" icon flat @click="$emit('onExport')" :loading="isDownloading"><v-icon>get_app</v-icon></v-btn>
				<span>Export CSV</span>
			</v-tooltip>
		</v-layout>
	</v-card-title>
</template>

<script>
	import TagSelector from '@/components/tags/TagSelector';
	export default {
		components: {
			TagSelector
		},
		props: {
			search: {
				type: String,
				default: undefined
			},
			assetCategories: {
				type: Array,
				default: []
			},
			assetLocations: {
				type: Array,
				default: []
			},
			assetStatuses: {
				type: Array,
				default: []
			},
			isDownloading: {
				type: Boolean,
				default: false
			},
			hideActions: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				selectedCategories: [],
				selectedLocations: [],
				selectedStatuses: []
			};
		},
		methods: {
			updateSearch(val) {
				this.$emit('updateSearch', val);
			},
			updateSelectedCategories(newSelectedCategories) {
				this.selectedCategories = newSelectedCategories;
				this.$emit('updateCategories', this.selectedCategories);
			},
			onLeaveCategorySelector() {
				this.$refs.focusAfterCategorySelector.focus();
			},
			updateSelectedLocations(newSelectedLocations) {
				this.selectedLocations = newSelectedLocations;
				this.$emit('updateLocations', this.selectedLocations);
			},
			onLeaveLocationSelector() {
				this.$refs.focusAfterLocationSelector.focus();
			},
			updateSelectedStatuses(newSelectedStatuses) {
				this.selectedStatuses = newSelectedStatuses;
				this.$emit('updateStatuses', this.selectedStatuses);
			}
		}
	};
</script>
